
import React from "react";
import "./RewardsTickHomePage.scss"
import HeaderText from "../components/Text/HeaderText";
import SubheaderText from "../components/Text/SubheaderText";
import secure from "../image/secure.svg"
import reward from "../image/reward.svg"
import heart from "../image/heart.svg"
import lightning from "../image/lightning.svg"
import wallet from "../image/wallet.svg"
import reload from "../image/reload.svg"
import ExpCard from "../components/Card/ExpCard/ExpCard";


const RewardsTickExpPage = () => {
    const experience = [
        {
            "icon": secure,
            "iconBgColor": "#059669",
            "header": "Instant Cashback",
            "subheader": "Get immediate cashback on every purchase. No waiting, no complications - just instant rewards in your wallet.",
            "bgColor": "linear-gradient(135deg, #ECFDF5 0%, #F0FDFA 100%)"
        },
        {
            "icon": reward,
            "iconBgColor": "#2563EB",
            "header": "Premium Rewards",
            "subheader": "Unlock exclusive rewards and premium benefits. The more you shop, the better your rewards become.",
            "bgColor": "linear-gradient(135deg, #EFF6FF 0%, #EEF2FF 100%)"
        }, {
            "icon": heart,
            "iconBgColor": "#9333EA",
            "header": "Social Gifting",
            "subheader": "Share rewards with friends and family. Spread the joy of savings and earn bonus points for referrals.",
            "bgColor": "linear-gradient(135deg, #FAF5FF 0%, #FDF2F8 100%)"
        }, {
            "icon": lightning,
            "iconBgColor": "#EA580C",
            "header": "Smart Deals",
            "subheader": "AI-powered deal recommendations tailored to your preferences. Never miss out on the best offers again.",
            "bgColor": "linear-gradient(135deg, #FFF7ED 0%, #FEF2F2 100%)"
        }, {
            "icon": wallet,
            "iconBgColor": "#0D9488",
            "header": "Digital Wallet",
            "subheader": "Secure digital wallet with multiple payment options. Manage all your rewards and payments in one place.",
            "bgColor": "linear-gradient(135deg, #F0FDFA 0%, #ECFEFF 100%)"
        }, {
            "icon": reload,
            "iconBgColor": "#16A34A",
            "header": "Easy Returns",
            "subheader": "Hassle-free returns and exchanges with full reward protection. Shop with confidence knowing you're covered.",
            "bgColor": "linear-gradient(135deg, #F0FDF4 0%, #ECFDF5 100%)"
        },
    ]
    return (
        <div className="RewardsTickExpPage">
            <div className="RewardsTickExpPage-inner">
                <HeaderText
                    text={"Why Choose RewardsTick"} />
                <div className="RewardsTickExpPage-subheader">
                    <SubheaderText
                        text={"Experience the future of shopping with our comprehensive rewards platform"}
                    />
                </div>
                <div className="RewardsTickExpPage-inner-grid">
                    {experience.map((exp, key) => {
                        return <ExpCard experience={exp} key={key} />
                    })}
                </div>
            </div>
        </div>
    )
}
export default RewardsTickExpPage